import moment from 'moment-timezone';

export function humanizeDate(day?: string, timezone?: string): string {
  if (!day) return '';
  const m = timezone ? moment.tz(day, timezone) : moment(day);
  return m.format('MMMM Do');
}

export function humanizeTime(time?: string, timezone?: string): string {
  if (!time) return '';
  const m = timezone ? moment.tz(time, timezone) : moment(time);
  return timezone ? m.format('h:mm a z') : m.format('h:mm a');
}
